export const partsWithVideos = ['bumper cover']

export const disableStyle = {
  pointerEvents: 'none',
  opacity: 0.5,
  backround: '#CCC',
}
